import { useEffect } from 'react';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getJobs } from '../../services/jobsService';
import {
  jobsFiltersState,
  jobsPageState,
  jobsState,
  loadingJobsState,
  searchJobsState,
  updateJobsState,
} from '../../storage/jobStates';
import { JobCore } from '../../types/jobs';
import { PaginatedProvider } from './PaginatedProvider';

export function JobsProvider() {
  const updateJobs = useRecoilValue(updateJobsState);
  const jobsFilters = useRecoilValue(jobsFiltersState);
  const resetUpdateJobs = useResetRecoilState(updateJobsState);
  const setPaginatedJobs = useSetRecoilState(jobsState);
  const setLoadingJobs = useSetRecoilState(loadingJobsState);
  const setJobsPage = useSetRecoilState(jobsPageState);

  useEffect(() => {
    setJobsPage(0);
  }, [jobsFilters]);

  return (
    <PaginatedProvider<JobCore>
      searchState={searchJobsState}
      pageState={jobsPageState}
      getPaginated={(page, search) => getJobs(page, search, jobsFilters)}
      setPaginated={setPaginatedJobs}
      onSearchChange={() => {
        // TODO: Do something if needed when search changes.
      }}
      onUpdateFinish={() => {
        resetUpdateJobs();
      }}
      setLoading={setLoadingJobs}
      update={updateJobs}
    />
  );
}
